module.exports = __webpack_public_path__ + "static/media/icon-duration.a8bf35ef.svg";